import { ref, reactive } from "vue";
import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import { Pack } from "@/interfaces/pack";
import { Subscription } from "@/interfaces/subscription";
import i18n from "@/i18n/index";
import {
  specializations,
  personTypes,
  paymentsTypes,
  cancellationTypes,
  contractsTypes,
  genders,
  packs,
  assurances,
  subscriptions,
  fees,
  bank_names,
  payment_methods,
  device_brands,
  supported_auth_methods,
  transactions_due_date,
  expired_subscriptions,
  subscriptions_expiring,
  transactions_due_date_count,
  expired_subscriptions_count,
  subscriptions_expiring_count,
  members_count,
  count_subscriptions_inactive,
  members_with_pointeuse_errors_count,
  count_subscriptions_active,
  count_members_dosent_have_subscription,
  count_members_canceled_subscription,
  count_members_paused_subscription,
  count_new_today_subscriptions,
  count_renewed_today_subscriptions,
  count_members_not_started_subscription,
  pointeuses,
  cash_journals,
  total_encaissements,
  total_decaissements,
  total_cashflow,
} from "@/shared/state";

import type {
  CashReport,
  AmountResponse,
  Regulation,
} from "@/interfaces/cashReport";
import {
  createCashReportState,
  createAmountResponse,
} from "@/shared/cashReport";

/**
 * Helper: assign API response safely
 */
const setAmountResponse = <T>(target: AmountResponse<T>, source: any) => {
  target.data = source?.regulations ?? [];
  target.total = source?.total ?? 0;
};

import {
  total_daily_cash_report,
  expense_regulations_amount,
  income_regulations_amount,
  today_regulations_amount,
  regulations_amount,
} from "@/shared/state";

const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;

export function useDashboard() {
  const error = ref<string | null>(null);
  const isRequestDashboard = ref<boolean | false>(false);

  const cashReport = reactive<CashReport>(createCashReportState());

  const getDashboardData = async (body: object) => {
    try {
      isRequestDashboard.value = true;
      const response = await authenticatedFetch(
        `${API_URL}dashboard`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );

      transactions_due_date.data =
        response?.notifications?.transactions_due_date || [];
      expired_subscriptions.data =
        response?.notifications?.expired_subscriptions || [];
      subscriptions_expiring.data =
        response?.notifications?.subscriptions_expiring || [];

      transactions_due_date_count.value =
        response?.notifications?.transactions_due_date_count || 0;
      expired_subscriptions_count.value =
        response?.notifications?.expired_subscriptions_count || 0;
      subscriptions_expiring_count.value =
        response?.notifications?.subscriptions_expiring_count || 0;

      members_count.value = response?.members_count || 0;
      count_subscriptions_inactive.value =
        response?.count_subscriptions_inactive || 0;
      members_with_pointeuse_errors_count.value =
        response?.members_with_pointeuse_errors_count || 0;
      count_members_dosent_have_subscription.value =
        response?.count_members_dosent_have_subscription || 0;
      count_members_canceled_subscription.value =
        response?.count_members_canceled_subscription || 0;
      count_members_paused_subscription.value =
        response?.count_members_paused_subscription || 0;
        count_new_today_subscriptions.value =
        response?.count_new_today_subscriptions || 0;
        count_renewed_today_subscriptions.value =
          response?.count_renewed_today_subscriptions || 0;
      count_members_not_started_subscription.value =
        response?.count_members_not_started_subscription || 0;
      count_subscriptions_active.value =
        response?.count_subscriptions_active || 0;

      isRequestDashboard.value = false;
      return response;
    } catch (err: any) {
      isRequestDashboard.value = false;
      error.value = err.message;
    }
  };
  const fetchDefaultApi = async (body: object) => {
    try {
      isRequestDashboard.value = true;
      const response = await authenticatedFetch(
        `${API_URL}default`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      assurances.data = response?.assurances || [];
      packs.data = response?.packs || [];
      subscriptions.data = response?.subscriptions || [];
      fees.data = response?.fees || [];
      cash_journals.data = response?.cash_journals || [];
      pointeuses.data = response?.pointeuses || [];

      bank_names.value = response?.bank_names || [];
      payment_methods.value = response?.payment_methods || [];
      device_brands.value = response?.device_brands || [];
      supported_auth_methods.value = response?.supported_auth_methods || [];
      specializations.value = response?.specializations || [];

      paymentsTypes.value = response?.paymentsTypes || [];
      contractsTypes.value = response?.contractsTypes || [];
      cancellationTypes.value = response?.cancellationTypes || [];
      isRequestDashboard.value = false;

      return response;
    } catch (err: any) {
      isRequestDashboard.value = false;
      error.value = err.message;
    }
  };
  /* const getDailyCashReport = async (body: object, page: string) => {
    try {
      isRequestDashboard.value = true;
      expense_regulations_amount.data = [];
      income_regulations_amount.data = [];

      //

      expense_regulations_amount.total = 0;
      income_regulations_amount.total = 0;

      //
      total_daily_cash_report.value = 0;

      const response = await authenticatedFetch(
        `${API_URL}daily-cash-report`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );

      expense_regulations_amount.data = response?.expense?.regulations;
      expense_regulations_amount.total = response?.expense?.total;

      income_regulations_amount.data = response?.income?.regulations;
      income_regulations_amount.total = response?.income?.total;

      total_encaissements.value = response?.encaissements ?? 0;
      total_decaissements.value = response?.decaissements ?? 0;
      total_cashflow.value = response?.cashflow ?? 0;
      console.log(total_encaissements?.value);

      if (page == "dashboard") {
        today_regulations_amount.total = 0;
        today_regulations_amount.data = [];
        today_regulations_amount.data = response?.member?.regulations;
        today_regulations_amount.total = response?.member?.total;
      }
      if (page == "reporting") {
        console.log(page);
        regulations_amount.total = 0;
        regulations_amount.data = [];
        regulations_amount.data = response?.member?.regulations;
        regulations_amount.total = response?.member?.total;
      }

      total_daily_cash_report.value = response?.global_total ?? 0;

      isRequestDashboard.value = false;
    } catch (err: any) {
      isRequestDashboard.value = false;
      error.value = err.message;
    }
  };*/

  /**
   * MAIN FUNCTION: Fetch daily cash report
   */
  const getDailyCashReport = async (
    body: object,
    page: "dashboard" | "reporting",
  ) => {
    isRequestDashboard.value = true;
    error.value = null;

    try {
      const response = await authenticatedFetch(
        `${API_URL}daily-cash-report`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );

      // Expense & Income & assurance
      setAmountResponse(cashReport.expense, response?.expense);
      setAmountResponse(cashReport.income, response?.income);
      setAmountResponse(cashReport.assurance, response?.assurances);
      setAmountResponse(cashReport.orders, response?.orders);

      // Global stats
      cashReport.encaissements = response?.encaissements ?? 0;
      cashReport.decaissements = response?.decaissements ?? 0;
      cashReport.cashflow = response?.cashflow ?? 0;
      cashReport.global_total = response?.global_total ?? 0;


      setAmountResponse(cashReport.member, response?.member); 


      console.log(cashReport);
    } catch (err: any) {
      error.value = err.message;
    } finally {
      isRequestDashboard.value = false;
    }
  };

  return {
    cashReport,
    getDailyCashReport,
    getDashboardData,
    fetchDefaultApi,
    isRequestDashboard,
  };
}
